import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['popover']

  declare readonly popoverTarget: HTMLDivElement

  trigger(e: MouseEvent): void {
    this.popoverTarget.togglePopover()

    e.preventDefault()
  }

  handleToggle = (): void => {
    this.element.dispatchEvent(
      new CustomEvent('ui-side-panel:toggle', {
        bubbles: true,
        detail: {
          isOpen: this.popoverTarget.matches(':popover-open')
        }
      })
    )
  }
}
